import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { planName } from "@/components/billing/PlanCards";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { t } from "@/i18n";

export default function PaymentResult() {
  const { pathname, search } = useLocation();
  const { loadMe } = useAuth();
  const sid = new URLSearchParams(search).get("session_id");
  const [state, setState] = useState(pathname.endsWith("cancel") || !sid ? "cancel" : "pending");
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    if (state !== "pending") return;
    let n = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setPlan(data.plan); setState("paid"); loadMe?.(); return; }
        if (data.status === "expired") return setState("failed");
      } catch { /* retry */ }
      if (++n >= 10) return setState("failed");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, state, loadMe]);

  const Icon = state === "paid" ? CheckCircle2 : state === "pending" ? Loader2 : XCircle;
  const msg = state === "paid" ? t("pay.success", { plan: planName(plan) }) : t(`pay.${state}`);
  return (
    <div className="mx-auto max-w-lg rounded-2xl border bg-card p-8 text-center" data-testid="payment-result">
      <Icon className={`mx-auto h-10 w-10 ${state === "paid" ? "text-primary" : "text-muted-foreground"} ${state === "pending" ? "animate-spin" : ""}`} />
      <p className="mt-4 text-lg font-semibold" data-testid={`payment-status-${state}`}>{msg}</p>
      <div className="mt-6 flex justify-center gap-2">
        <Button asChild variant="outline" data-testid="payment-plans-btn"><Link to="/tarifs">{t("quota.upgrade")}</Link></Button>
        <Button asChild data-testid="payment-settings-btn"><Link to="/settings">{t("pay.back")}</Link></Button>
      </div>
    </div>
  );
}
